import { render, staticRenderFns } from "./PostPrivacyTooltip.vue?vue&type=template&id=303e243c&scoped=true"
import script from "./PostPrivacyTooltip.vue?vue&type=script&lang=js"
export * from "./PostPrivacyTooltip.vue?vue&type=script&lang=js"
import style0 from "./PostPrivacyTooltip.vue?vue&type=style&index=0&id=303e243c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303e243c",
  null
  
)

export default component.exports